import { render, staticRenderFns } from "./IcoCoaching.vue?vue&type=template&id=0ff803cc&"
import script from "./IcoCoaching.vue?vue&type=script&lang=js&"
export * from "./IcoCoaching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports